export default function template() {
    throw new Error("Template implementation missing.");
}
